import { Message } from '../types/chat';

interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

const formatHistory = (messages: Message[]): ChatMessage[] => {
  return messages.map(msg => ({
    role: msg.sent ? 'user' : 'assistant',
    content: msg.text
  }));
};

export const getAIResponse = async (query: string, chatHistory: Message[] = []) => {
  try {
    const formattedHistory = formatHistory(chatHistory);
    const historyText = formattedHistory.map(msg => `${msg.role}: ${msg.content}`).join('\n');
    
    // Create a prompt that includes context about the chat history
    const promptWithContext = `
Previous conversation:
${historyText}

Based on this conversation history, please respond to: ${query}

Remember to:
1. Consider the context from previous messages
2. Maintain continuity with earlier discussions
3. Reference relevant information from the chat history when appropriate
4. Provide a coherent response that builds on the ongoing conversation

Current user message: ${query}
`;

    const response = await fetch("https://charan5775-fastest.hf.space/t2t", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: promptWithContext,
        stream: false
      })
    });
    
    const data = await response.json();
    return data.response || data;
  } catch (error) {
    console.error('Error getting AI response:', error);
    return "Sorry, I couldn't process that request.";
  }
}; 